import MUIProgressionBar from "@material-ui/core/LinearProgress";
import React from "react";

import { Bar } from "./Bar";

interface IProps {
  loading: boolean;
}

const ProgressionBar: React.FC<IProps> = ({ loading }) =>
  loading ? (
    <Bar>
      <MUIProgressionBar color="primary" />
    </Bar>
  ) : null;

export { ProgressionBar };
